import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { reactive, ref, watch } from 'vue';
import { useComponentModalInstance } from '@/share/components';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-u-dict-cate-form',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const $modal = useComponentModalInstance();
    const props = __props;
    const formData = reactive({
      id: props.id,
      name: '',
      desc: ''
    });
    const formRules = reactive({
      name: [{
        required: true,
        message: '字典名称不能为空',
        trigger: 'blur'
      }]
    });
    const {
      loading,
      runAsync: getCateDetailApi
    } = fetchApi('common.uDictionary.getCateDetail');
    const {
      loading: saveLoading,
      runAsync: saveCateApi
    } = fetchApi('common.uDictionary.saveCate');
    const loadCateDetail = async id => {
      if (!id) return Promise.resolve(false);
      const {
        error,
        ...res
      } = await getCateDetailApi({
        id
      });
      if (error) return Promise.resolve(false);
      Object.assign(formData, res);
      return Promise.resolve(res);
    };
    const updateModalConfirmButtonLoading = loading => {
      if (!$modal) return;
      $modal.setModalOptions({
        confirmLoading: loading
      });
    };
    watch(() => saveLoading.value, loading => {
      updateModalConfirmButtonLoading(loading);
    });
    const submit = async () => {
      const $form = formRef.value;
      if (!$form) return Promise.resolve(false);
      const errors = await $form.validate();
      if (errors) return Promise.resolve(false);
      const {
        error,
        ...res
      } = await saveCateApi({
        ...formData,
        id: props.id
      });
      if (error) return Promise.resolve(false);
      return Promise.resolve(res);
    };
    watch(() => props.id, id => {
      loadCateDetail(id);
    }, {
      immediate: true
    });
    __expose({
      submit,
      confirmListener: submit
    });
    return (_ctx, _cache) => {
      const _component_vxe_input = _resolveComponent("vxe-input");
      const _component_vxe_form_item = _resolveComponent("vxe-form-item");
      const _component_vxe_textarea = _resolveComponent("vxe-textarea");
      const _component_vxe_form = _resolveComponent("vxe-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_form, {
        ref_key: "formRef",
        ref: formRef,
        "title-width": "100",
        "title-colon": "",
        "title-align": "right",
        data: formData,
        rules: formRules,
        loading: _unref(loading)
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_form_item, {
          span: "24",
          field: "name",
          title: "字典名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_input, {
            modelValue: formData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.name = $event),
            placeholder: "请输入字典名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "24",
          field: "desc",
          titel: "字典说明"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_textarea, {
            modelValue: formData.desc,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.desc = $event),
            autosize: {
              minRows: 1,
              maxRows: 3
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "rules", "loading"])]);
    };
  }
};